export class ProcurementSearchRequest {
  size: number;
  pageNumber: number;
  sortColumn: string | null;
  sortDirection: number | null;
  fullName?: string;
  poNumber?: string;
  type?: string;
  projectCode?: string;
  poStartDate?: string;
  poEndDate?: string;
  status?: string;

  constructor(
    pageNumber: number,
    size: number,
    sortColumn: string | null,
    sortDirection: number | null
  ) {
    this.pageNumber = pageNumber;
    this.size = size;
    this.sortColumn = sortColumn;
    this.sortDirection = sortDirection;
  }
}
